import { NavigateOptions, useNavigate, useSearchParams } from 'react-router-dom'
import { SignalementContext } from '../contexts/signalement.context'
import { useContext, useCallback } from 'react'

const searchParamsToPreserve = ['sourceId']

function useNavigateWithPreservedSearchParams() {
  const _navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { signalement, deleteSignalement } = useContext(SignalementContext)

  const navigate = useCallback(
    (to: string, params: Record<string, string> = {}, options?: NavigateOptions) => {
      if (signalement) {
        deleteSignalement()
      }

      const paramsToPreserve = searchParamsToPreserve.reduce(
        (acc, param) => {
          const value = searchParams.get(param)
          if (value) {
            acc[param] = value
          }
          return acc
        },
        {} as Record<string, string>,
      )

      const mergedParams = new URLSearchParams({
        ...paramsToPreserve,
        ...params,
      })

      const queryString = mergedParams.toString()
      const url = queryString ? `${to}?${queryString}` : to

      _navigate(url, options)
    },
    [signalement, deleteSignalement, searchParams, _navigate],
  )

  return { navigate }
}

export default useNavigateWithPreservedSearchParams
